export const WILDIX_METADATA = 'wildixMetadata';
